export const isValueInEnum = <T extends string>(
  enumObject: Record<string, T>,
  value: T,
): boolean => {
  return Object.values(enumObject).includes(value);
};
